import { render, staticRenderFns } from "./CompanyBasicInfo.vue?vue&type=template&id=9de57e96&"
import script from "./CompanyBasicInfo.vue?vue&type=script&lang=ts&"
export * from "./CompanyBasicInfo.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyBasicInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports